import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Icon } from '../icons';

// Modale leggera e autosufficiente: inietta i propri stili una volta sola
// (stesso approccio di HelpTip, usa i token del design system su :root/.light/
// .dark) cosi' non dipende da App.css. Chiude con Esc, click sul backdrop o
// sulla X. Renderizzata in un portal su document.body per stare sopra le card
// che usano backdrop-filter.
const STYLE_ID = 'modal-styles';
const CSS = `
.modal-backdrop {
  position: fixed; inset: 0; z-index: 60; display: grid; place-items: center;
  padding: 1rem; background: rgba(8, 10, 18, .55);
  backdrop-filter: blur(3px); -webkit-backdrop-filter: blur(3px);
  animation: modal-fade .16s ease;
}
.modal-card {
  width: min(460px, 100%); max-height: calc(100vh - 2rem); overflow-y: auto;
  background: var(--bg-glass-strong);
  backdrop-filter: blur(var(--blur)); -webkit-backdrop-filter: blur(var(--blur));
  border: 1px solid var(--border-default); border-radius: 14px;
  box-shadow: 0 24px 64px var(--shadow-color);
  padding: 1.25rem; animation: modal-pop .18s ease;
}
.modal-head { display: flex; align-items: center; gap: .55rem; margin-bottom: .9rem; }
.modal-head h3 { margin: 0; font-size: 1.05rem; }
.modal-head .modal-close { margin-left: auto; }
.modal-actions { display: flex; gap: .6rem; justify-content: flex-end; margin-top: 1.2rem; flex-wrap: wrap; }
@keyframes modal-fade { from { opacity: 0; } to { opacity: 1; } }
@keyframes modal-pop { from { opacity: 0; transform: translateY(8px) scale(.98); } to { opacity: 1; transform: none; } }
`;

function ensureStyles() {
  if (typeof document === 'undefined' || document.getElementById(STYLE_ID)) return;
  const s = document.createElement('style');
  s.id = STYLE_ID;
  s.textContent = CSS;
  document.head.appendChild(s);
}

function Modal({ title, icon = 'users', onClose, children }) {
  useEffect(ensureStyles, []);
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return createPortal(
    <div className="modal-backdrop" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="modal-card" role="dialog" aria-modal="true" aria-label={title}>
        <div className="modal-head">
          <Icon name={icon} size={18} />
          <h3>{title}</h3>
          <button type="button" className="icon-btn modal-close" aria-label="Chiudi" onClick={onClose}>
            <Icon name="x" size={16} />
          </button>
        </div>
        {children}
      </div>
    </div>,
    document.body
  );
}

export default Modal;
